import React from 'react';

import { CollectionCard } from '~src/app/spaces/CardView/CollectionCard';
import { ConnectedCollectionDetailsDialogBody } from '~src/app/spaces/Collections/CollectionDetailsDialog';
import { CollectionsResourceQuery } from '~src/app/spaces/Collections/ResourceQuery/CollectionsResourceQuery';
import { ICollectionInfo } from '~src/app/spaces/Collections/ICollectionInfo';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { SpaceDefinition, ExplorableItemDefinition, MixedContentItemDefinition, ContentTypeFilterClause } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { ContentFiltersKeys } from '~src/ts/models/ContentFilters';
import { IContentInfo } from '~src/ts/models/IContentInfo';

import { getNoDefaultFilters } from './getDefaultFilters';

export const CollectionDefinition: SpaceDefinition<'collection'> & ExplorableItemDefinition & MixedContentItemDefinition = {
  itemType: 'collection',
  singularName: Messages.collection,
  pluralName: Messages.collections,
  emptyStateMessage: Messages.collectionsEmptyMessage,
  contentFilterKeys: [
    ContentFiltersKeys.search,
    ContentFiltersKeys.owner,
    ContentFiltersKeys.updatedTimeAfter,
    ContentFiltersKeys.updatedTimeBefore,
    ContentFiltersKeys.createdTimeAfter,
    ContentFiltersKeys.createdTimeBefore,
    ContentFiltersKeys.favorite,
    ContentFiltersKeys.hideEmptyCollections,
    ContentFiltersKeys.collectionVisibility
  ],
  defaultFilters: getNoDefaultFilters,
  cardComponent: CollectionCard,
  listViewIconUrl: imgPath('collection_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['collection']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return new CollectionsResourceQuery();
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list', 'thumbnail'],
  contentType: 'collection',
  fieldValueResourceType: 'collection',
  contentSpaceUrl: (urls, _contentId, luid) => urls.collectionUrl(luid),
  headerIconPath: () => undefined, // we don't want to show a header icon for collections
  detailDialogTitle: Messages.collectionsDetailsTitle,
  detailDialogBody: (content: IContentInfo<'collection'>) => {
    return <ConnectedCollectionDetailsDialogBody collection={content as ICollectionInfo}/>;
  },
  siteFilterByTypeDropdownName: Messages.collection
};
